import React from 'react'
import styled from '@emotion/styled'
import { Icon } from '@mobi/component-library/Assets/Icon'
import { Button } from '@mobi/component-library/Base/Buttons'
import { font, spacing } from '@mobi/component-library/Foundations'
import { QuickShare } from '@core/Areas/BetLoop/Components/QuickShare'

export const EmptyProfile: React.FC<{ isMyProfile: boolean }> = ({ isMyProfile }) => {
  const [isQuickShareOpen, setIsQuickShareOpen] = React.useState(false)

  const handleQuickShareClick = () => setIsQuickShareOpen(curr => !curr)
  const handleQuickShareDismiss = () => setIsQuickShareOpen(curr => !curr)

  return (
    <WrapperStyled>
      <span>No Shared Bets</span>

      {!isMyProfile ? (
        <span>This profile hasn’t shared any bets yet. Check back later!</span>
      ) : (
        <>
          <span>Start posting to the Hub from your pending bets</span>

          <Button onClick={handleQuickShareClick} color='primary' size='sm'>
            Share a Bet
            <Icon name='CustomAddBet' />
          </Button>

          <QuickShare isOpen={isQuickShareOpen} onDismiss={handleQuickShareDismiss} />
        </>
      )}
    </WrapperStyled>
  )
}

// ======
// Styles
// ======

const WrapperStyled = styled.div({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  padding: `${spacing.lgx2} ${spacing.huge}`,
  fontSize: font.size.lg.fontSize,
  lineHeight: font.size.lg.lineHeight,
  fontWeight: font.weight.regular,
  textAlign: 'center',

  '> span:first-of-type': {
    fontWeight: font.weight.semibold,
  },

  '> span:nth-of-type(2)': {
    maxWidth: '25rem',
  },

  '> button': {
    alignSelf: 'center',
    marginTop: spacing.md,
  },
})
